import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { resetPasswordRequest } from '../ducks';
import { ResetPasswordForm } from '../components';

const mapStateToProps = (state, props) => ({
  passwordResetToken: props.params.passwordResetToken,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      resetPasswordRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class ResetPasswordContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    passwordResetToken: PropTypes.string.isRequired,
  };

  render() {
    const { actions, passwordResetToken } = this.props;

    return (
      <ResetPasswordForm
        onSubmit={actions.resetPasswordRequest}
        passwordResetToken={passwordResetToken}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/containers/ResetPasswordContainer.js